import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasRonda() {
  return (
    <CityPagePersianas
      name="Ronda"
      slug="ronda"
      cp="29400"
      poblacion={33800}
      zonaGeo="Serranía de Ronda"
      lat={36.7403}
      lng={-5.1654}
      zonas={[
        "Centro Ronda",
        "La Dehesa",
        "El Mercadillo",
        "Barrio de San Francisco",
      ]}
      landmarks={[
        "Puente Nuevo",
        "Plaza de Toros",
        "Casa del Rey Moro",
        "Tajo de Ronda",
      ]}
      municipiosLimitrofes={[
        "Arriate",
        "Benaoján",
        "Setenil de las Bodegas",
      ]}
      festivalLocal="Feria de Pedro Romero, primera semana de septiembre"
      contextoTipologico="Ciudad histórica turística, casas tradicionales con persianas verdes, hostelería abundante con toldos."
      isCoreZone={false}
    />
  );
}